import {
  IGetUserByPlantEmail,
  IGetUserSaleInCombobox,
} from 'interfaces/TeamSale/TeamSale';

export interface IUserParams {
  page: number;
  pageSize: number;
  plantCode?: string;
  role?: string;
  email?: string;
  fullName?: string;
  jobTitle?: string;
}

export interface IGetUserRoleSaleInCBB {
  plantCode: string;
}

export type IUpdateUserRoleParams = Omit<IUserParams, 'page' | 'pageSize'> & {
  id: string;
};

export interface IGetUsersNotTeamSale {
  activeRoute: boolean;
  contains?: string;
}

export const GET_USERS = {
  getAllUser: (params: IUserParams) => {
    const { page, pageSize, fullName, email, role, jobTitle } = params;

    return {
      take: pageSize,
      skip: (page - 1) * pageSize,
      input: {
        ...(email && { email: { contains: email } }),
        ...(fullName && { fullName: { contains: fullName } }),
        ...(role && {
          trole: {
            OR: [
              {
                name: {
                  contains: role,
                },
              },
              {
                id: {
                  contains: role,
                },
              },
            ],
          },
        }),
        ...(jobTitle && {
          tjobtitle: {
            OR: [
              {
                jobName: {
                  contains: jobTitle,
                },
              },
              {
                id: {
                  contains: jobTitle,
                },
              },
            ],
          },
        }),
      },
    };
  },
  getUsersNotTeamSale: (params: IGetUsersNotTeamSale) => {
    return {
      input: {
        activeRoute: { equals: false },
        OR: [
          { id: { contains: params.contains || '' } },
          { fullName: { contains: params.contains || '' } },
          { email: { contains: params.contains || '' } },
        ],
      },
    };
  },
  updateUserRole: (params: IUpdateUserRoleParams) => {
    const { id, fullName, email, role, plantCode } = params;

    return {
      data: {
        ...(id && { id: id }),
        role: role || null,
        // ...(role && { role: role }),
        ...(email && { email: email }),
        ...(fullName && { fullName: fullName }),
        ...(plantCode && { plantCode: plantCode }),
      },
    };
  },
  getUserRoleSaleInCBB: (params: IGetUserSaleInCombobox) => {
    const { plantId, page, pageSize } = params;

    return {
      take: pageSize,
      skip: (page - 1) * pageSize,
      input: {
        AND: [{ ...(plantId && { plantCode: { equals: plantId } }) }],
        OR: [
          { ...(params.email && { email: { contains: params.email } }) },
          { ...(params.email && { id: { contains: params.email } }) },
          { ...(params.email && { fullName: { contains: params.email } }) },
        ],
        role: {
          equals: 'sale',
        },
      },
    };
  },
  getUserByPlantEmail: ({ email }: IGetUserByPlantEmail) => {
    return {
      input: {
        // plantCode: { equals: plantCode },
        email: { contains: email },
      },
    };
  },
};

export const VARIABLES_GET_USER_BY_PLANT = (params: any) => {
  const { plantCode } = params;
  return {
    input: {
      ...(plantCode && { plantCode: { equals: plantCode } }),
    },
  };
};
